module.exports = "/assets/data/050cdc38ded56e9fadb913a3ba25e3ed-HA4.data.json";